var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToCcheckboxchecked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5.001H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5v-23a.5.5 0 0 0-.5-.5m-6.158 8.866-7.5 7a.5.5 0 0 1-.695-.012l-2.5-2.5a.5.5 0 0 1 .707-.707l2.158 2.158 7.147-6.67a.5.5 0 0 1 .683.731"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToCcheckboxchecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TOCcheckboxchecked.svg";